import { createPageLoadingTracker } from "../utils/page-loading-tracker";

const IGNORED_PAGE_LOADING_KINDS = new Set(["error", "element", "initial"]);

const LoadingIndicatorHook = {
  mounted() {
    this.fallbackTimer = null;

    this.clearFallback = () => {
      if (this.fallbackTimer) {
        clearTimeout(this.fallbackTimer);
        this.fallbackTimer = null;
      }
    };

    this.scheduleFallback = () => {
      this.clearFallback();
      // Prevent a permanently visible loading bar when stop events are missed.
      this.fallbackTimer = setTimeout(() => this.reset(), 8000);
    };

    this.show = () => {
      this.el.classList.remove("hidden");
      this.el.classList.add("animate-pulse");
    };

    this.hide = () => {
      this.el.classList.add("hidden");
      this.el.classList.remove("animate-pulse");
    };

    this.resetUI = () => {
      this.clearFallback();
      this.hide();
    };

    this.tracker = createPageLoadingTracker({
      ignoredKinds: IGNORED_PAGE_LOADING_KINDS,
      debugStorageKey: "lv:page-loading-debug",
      onActiveCountChange: (activeCount) => {
        if (activeCount > 0) {
          this.scheduleFallback();
          this.show();
          return;
        }
        this.resetUI();
      },
    });

    this.reset = () => {
      this.tracker.reset();
      this.resetUI();
    };

    this.hide();

    window.addEventListener("phx:page-loading-start", this.tracker.onStart);
    window.addEventListener("phx:page-loading-stop", this.tracker.onStop);
    window.addEventListener("beforeunload", this.reset);
  },
  destroyed() {
    window.removeEventListener("phx:page-loading-start", this.tracker.onStart);
    window.removeEventListener("phx:page-loading-stop", this.tracker.onStop);
    window.removeEventListener("beforeunload", this.reset);
    this.clearFallback();
  },
};

export default LoadingIndicatorHook;
